import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Anchor, AnchorLink} from 'kpc';

var _$tmp0 = {
    'id': 'section1-1'
};
var _$tmp1 = {
    'id': 'section1-2-1'
};
var _$tmp2 = {
    'id': 'section1-2-2'
};
var _$tmp3 = {
    'id': 'section1-2'
};
var _$tmp4 = {
    'id': 'section1-3'
};
var _$tmp5 = {
    'id': 'section1'
};
var _$tmp6 = {
    'id': 'section2-1'
};
var _$tmp7 = {
    'id': 'section2-2'
};
var _$tmp8 = {
    'id': 'section2'
};
var _$tmp9 = {
    'id': 'section3'
};
var _$tmp10 = {
    'id': 'scroll-container3'
};
var _$tmp11 = {
    'href': 'section1-1',
    'title': 'Part1.1'
};
var _$tmp12 = {
    'href': 'section1-2-1',
    'title': 'Part1.2.1'
};
var _$tmp13 = {
    'href': 'section1-2-2',
    'title': 'Part1.2.2'
};
var _$tmp14 = {
    'href': 'section1-3',
    'title': 'Part1.3'
};
var _$tmp15 = {
    'href': 'section2-1',
    'title': 'Part2.1'
};
var _$tmp16 = {
    'href': 'section2-2',
    'title': 'Part2.2'
};
var _$tmp17 = {
    'href': 'section3',
    'title': 'Part3'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$ce(2, 'h2', 'Part1', 16 /* HasTextChildren */),
                _$ce(2, 'p', '这是Part1的内容', 16 /* HasTextChildren */),
                _$ce(2, 'div', [
                    _$ce(2, 'h3', 'Part1.1', 16 /* HasTextChildren */),
                    _$ce(2, 'p', '这是Part1.1', 16 /* HasTextChildren */)
                ], 4 /* HasNonKeyedChildren */, 'subsection', _$tmp0),
                _$ce(2, 'div', [
                    _$ce(2, 'h3', 'Part1.2', 16 /* HasTextChildren */),
                    _$ce(2, 'p', '这是Part1.2的内容', 16 /* HasTextChildren */),
                    _$ce(2, 'div', [
                        _$ce(2, 'h4', 'Part1.2.1', 16 /* HasTextChildren */),
                        _$ce(2, 'p', '这是Part1.2.1的内容', 16 /* HasTextChildren */)
                    ], 4 /* HasNonKeyedChildren */, 'subsubsection', _$tmp1),
                    _$ce(2, 'div', [
                        _$ce(2, 'h4', 'Part1.2.2', 16 /* HasTextChildren */),
                        _$ce(2, 'p', '这是Part1.2.2的内容', 16 /* HasTextChildren */)
                    ], 4 /* HasNonKeyedChildren */, 'subsubsection', _$tmp2)
                ], 4 /* HasNonKeyedChildren */, 'subsection', _$tmp3),
                _$ce(2, 'div', [
                    _$ce(2, 'h3', 'Part1.3', 16 /* HasTextChildren */),
                    _$ce(2, 'p', '这是Part1.3的内容', 16 /* HasTextChildren */)
                ], 4 /* HasNonKeyedChildren */, 'subsection', _$tmp4)
            ], 4 /* HasNonKeyedChildren */, 'section section1', _$tmp5),
            _$ce(2, 'div', [
                _$ce(2, 'h2', 'Part2', 16 /* HasTextChildren */),
                _$ce(2, 'p', '这是Part2的内容', 16 /* HasTextChildren */),
                _$ce(2, 'div', [
                    _$ce(2, 'h3', 'Part2.1', 16 /* HasTextChildren */),
                    _$ce(2, 'p', '这是Part2.1的内容', 16 /* HasTextChildren */)
                ], 4 /* HasNonKeyedChildren */, 'subsection', _$tmp6),
                _$ce(2, 'div', [
                    _$ce(2, 'h3', 'Part2.2', 16 /* HasTextChildren */),
                    _$ce(2, 'p', '这是Part2.2的内容', 16 /* HasTextChildren */)
                ], 4 /* HasNonKeyedChildren */, 'subsection', _$tmp7)
            ], 4 /* HasNonKeyedChildren */, 'section section2', _$tmp8),
            _$ce(2, 'div', [
                _$ce(2, 'h2', 'Part3', 16 /* HasTextChildren */),
                _$ce(2, 'p', '这是Part3的内容', 16 /* HasTextChildren */)
            ], 4 /* HasNonKeyedChildren */, 'section section3', _$tmp9)
        ], 4 /* HasNonKeyedChildren */, 'scroll-container3', _$tmp10),
        _$cc(Anchor, {
            'container': '#scroll-container3',
            'children': [
                _$cc(AnchorLink, {
                    'href': 'section1',
                    'title': 'Part1',
                    'children': [
                        _$cc(AnchorLink, _$tmp11),
                        _$cc(AnchorLink, {
                            'href': 'section1-2',
                            'title': 'Part1.2',
                            'children': [
                                _$cc(AnchorLink, _$tmp12),
                                _$cc(AnchorLink, _$tmp13)
                            ]
                        }),
                        _$cc(AnchorLink, _$tmp14)
                    ]
                }),
                _$cc(AnchorLink, {
                    'href': 'section2',
                    'title': 'Part2',
                    'children': [
                        _$cc(AnchorLink, _$tmp15),
                        _$cc(AnchorLink, _$tmp16)
                    ]
                }),
                _$cc(AnchorLink, _$tmp17)
            ],
            'ev-$model:value': function($v) {
                $this.set('activeAnchor', $v);
            },
            'value': $this.get('activeAnchor')
        })
    ], 4 /* HasNonKeyedChildren */, 'anchor-demo');
};